<div
	fxLayout="column"
	fxLayout.lt-md="column"
	fxFlex="100%"
	fxLayoutAlign="start start"
	ngClass.lt-md="p-t-s p-b-s"
>
	<div fxLayout="column" fxLayoutAlign="start start">
		<a [href]="ratingsHref">
			<img
				src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/ratingsFooter/public"
			/>
		</a>
		<a i18n="@@footer_label_raitings" [href]="ratingsHref" class="break-word">
			4.8 / 5 average Trustpilot<br />
			and Google Rating</a
		>
	</div>
</div>
